import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Force users to add a facebook login with devise omniauth",
  "description": "",
  "published": "2013-06-20T00:00:00.000Z",
  "redirect_from": ["/blog/force-users-to-add-a-facebook-login-with-devise-omniauth/swizec/6250"],
  "categories": "devise, Facebook, Login, omniauth, Ruby, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You've set up rails with `}<a parentName="p" {...{
        "href": "https://github.com/plataformatec/devise"
      }}>{`devise`}</a>{` and `}<a parentName="p" {...{
        "href": "http://www.omniauth.org/"
      }}>{`omniauth`}</a>{`. Users are signing up with facebook or twitter or email&password or something completely different. Everything is going great.`}</p>
    <p>{`Now you want to force some users to add a facebook login to their account. Maybe you just want to see if their name and avatar match what they've set up in your service to make sure they really are who they say they are. Whatever.`}</p>
    <p>{`It seems like you might need to add a custom Devise strategy. You start googling. Doesn't seem like a lot of work, you just extend `}<inlineCode parentName="p">{`Authorizable`}</inlineCode>{` and override the `}<inlineCode parentName="p">{`authorize!`}</inlineCode>{` function and then ... do `}<em parentName="p">{`something`}</em>{`. Seems you'll have to mostly override how authorization works. Will that play well with `}<inlineCode parentName="p">{`omniauthable`}</inlineCode>{`?`}</p>
    <p>{`But that only solves the problem of forcing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Facebook",
        "title": "Facebook"
      }}>{`Facebook`}</a>{` on authorization. Who's going to check the conditions on every page load and sign the user out?`}</p>
    <p>{`You set up a filter. Put it in `}<inlineCode parentName="p">{`application_controller`}</inlineCode>{` and it's just a big mess. You're still not sure how to tie everything together and the clusterfuck of code is growing and growing.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/statuses/347024137086173185"
      }}>{`https://twitter.com/Swizec/statuses/347024137086173185`}</a></p>
    <h2 {...{
      "id": "force-fb-with-just-19-sloc"
    }}>{`Force FB with just 19 sloc`}</h2>
    <p>{`There's a better way!`}</p>
    <p>{`I stumbled on this solution almost by accident after ending up on an obscure API doc page on my gazillionth google search. Turns out you can force a user to sign up with facebook in just under 19 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Source_lines_of_code",
        "title": "Source lines of code"
      }}>{`lines of code`}</a>{`.`}</p>
    <p>{`We have to extend how `}<em parentName="p">{`models`}</em>{` behave, not create a new Devise strategy. The function we're looking to override is `}<inlineCode parentName="p">{`active_for_authentication?`}</inlineCode>{`.`}</p>
    <p>{`This function is called on every page load when a user is signed in and checks that they're still active. If it returns `}<inlineCode parentName="p">{`false`}</inlineCode>{` the user will be signed out and asked to login before continuing. They won't be let through until the function returns `}<inlineCode parentName="p">{`true`}</inlineCode>{`.`}</p>
    <p>{`Elegant!`}</p>
    <p>{`All you have to do is put something like this in your `}<inlineCode parentName="p">{`app/classes`}</inlineCode>{` directory.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`module Facebookable
  extend ActiveSupport::Concern

  def needs_facebook?
    needs_facebook && services.where("provider = 'Facebook'").count < 1
  end

  def should_flag?
    condition # get a score somehow

    if condition
      self.needs_facebook = true
      self.save!
    end
  end

  def active_for_authentication?
    super && !needs_facebook? && !should_flag?()
  end

  def inactive_message
    needs_facebook? ? "Please sign in with Facebook." : super
  end
end
`}</code></pre>
    <p>{`And that's essentially it. Add a boolean `}<inlineCode parentName="p">{`needs_facebook`}</inlineCode>{` field to your user model and add `}<inlineCode parentName="p">{`:facebookable`}</inlineCode>{` to the strategies list and you're done. Everything works.`}</p>
    <p>{`Facebookable will automatically take care of checking whether a user has facebook connected and kick them out if they don't but should. On every page load it will also check whatever condition you've set and flag the user.`}</p>
    <p>{`It took me four days to come up with those 19 lines of code because nobody's written a blogpost about how to do this properly. Now someone has.`}</p>
    <p>{`PS: testing this works the same as testing any other model methods.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=98e2b5a1-87ba-4afc-b043-b54b490c314d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      